import Vue from 'vue'

import { Colors, regExp } from '@sigma-frontend-libs/commons'

import { buttonModes, components, icons, services } from '@/utils'

import button from '@/components/button'
import info from '@/components/info'

function renderTitle(h) {
  return h(
    'div',
    {},
    [ this.getTranslate(`${services.recover}.title`) ]
  )
}
function renderPlatformTitle(h) {
  const title = this.globalSettings?.frontend?.title
  if (title) {
    return h(
      'div',
      {
        class: 'text--grey'
      },
      [ title ]
    )
  }
}
function renderHeader(h) {
  return h(
    'div',
    {
      class: {
        [`${services.recover}__header`]: true,
        title: this.viewport.size.width <= 768,
        headline: this.viewport.size.width > 768
      }
    },
    [
      renderTitle.call(this, h),
      renderPlatformTitle.call(this, h)
    ]
  )
}

function renderValidationResult(h) {
  if (this.isValidationResult) {
    return h(
      info,
      {
        props: {
          value: this.getTranslate(`${services.recover}.notifications.success.request.recover`),
          icon: icons.check_circle,
          color: Colors.success
        }
      }
    )
  }
}
function renderLoginField(h) {
  if (this.validation === undefined) {
    return h(
      components['text-field'],
      {
        props: {
          value: this.login,
          disabled: this.loading,
          label: this.getTranslate(`${services.recover}.labels.login`),
          hint: this.getTranslate(`${services.recover}.hints.login`),
          required: true,
          clearable: true,
          autofocus: true,
          details: true,
          mask: regExp.usernameSoftForRecover
        },
        on: {
          input: event => {
            this.login = event
          },
          keypress: event => {
            if (event.keyCode === 13) {
              this.requestRecover()
            }
          }
        }
      }
    )
  }
}
function renderPasswordField(h) {
  if (this.validation === true && this.state === 'key') {
    let passwordType = 'password'
    let afterIcon = icons.visibility
    if (this.passwordVisibility) {
      passwordType = 'text'
      afterIcon = icons.visibility_off
    }

    return h(
      components['text-field'],
      {
        props: {
          name: 'password',
          value: this.password,
          label: this.getTranslate(`${services.recover}.labels.password`),
          hint: this.getTranslate(`${services.recover}.hints.password`),
          disabled: this.loading,
          type: passwordType,
          afterIcon,
          afterIconCallback: () => {
            this.passwordVisibility = !this.passwordVisibility
          },
          required: true,
          autofocus: true,
          clearable: true
        },
        on: {
          input: event => {
            this.password = event
          }
        }
      }
    )
  }
}
function renderBody(h) {
  return h(
    components.card,
    {
      class: {
        [`${services.recover}__body`]: true,
        [`${services.recover}__body--validation`]: this.isValidationResult
      },
      props: {
        outline: true,
        rounded: true
      }
    },
    [
      renderLoginField.call(this, h),
      renderPasswordField.call(this, h),
      renderValidationResult.call(this, h)
    ]
  )
}

function renderLoginButton(h) {
  return h(
    button,
    {
      props: {
        label: this.getTranslate('misc.buttons.signin'),
        mode: buttonModes.flat
      },
      on: {
        click: () => {
          Vue.router.push({ name: 'login' })
        }
      }
    }
  )
}
function renderResetButton(h) {
  let resetButtonKey = 'request'
  if (this.$_key) {
    resetButtonKey = 'reset'
  }

  return h(
    button,
    {
      props: {
        label: this.getTranslate(`${services.recover}.buttons.${resetButtonKey}`),
        mode: buttonModes.filled,
        color: Colors.primary,
        loading: this.loading,
        disabled: this.$_disabled
      },
      on: {
        click: () => {
          if (this.$_key) {
            this.changePassword()
          } else {
            this.requestRecover()
          }
        }
      }
    }
  )
}
function renderFooter(h) {
  return h(
    'div',
    {
      class: `${services.recover}__footer`
    },
    [
      renderLoginButton.call(this, h),
      renderResetButton.call(this, h)
    ]
  )
}

export default function(h) {
  return h(
    'div',
    {
      class: `${services.recover}`
    },
    [
      renderHeader.call(this, h),
      renderBody.call(this, h),
      renderFooter.call(this, h)
    ]
  )
}
